import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
var Radium = require('radium');

class Selectpicker extends Component {
componentDidMount = () =>  {
		var node = ReactDOM.findDOMNode(this.refs.selectpicker);
		//set default value if given
		if (this.props.defaultValue!=null){
			if(this.props.defaultValue.parentId!==undefined){
				node.value = JSON.stringify(
					{'parentId': this.props.defaultValue.parentId,
						'childId': this.props.defaultValue.childId
					});
				this.props.onChange({
					parentId: this.props.defaultValue.parentId,
					childId: this.props.defaultValue.childId
				});
			}
			else{
				node.value = this.props.defaultValue;
				this.props.onChange(this.props.defaultValue);
			}
		}
		else{

			this.props.onChange(node.value)
		}
	};
	componentWillReceiveProps = (nextProps) =>  {
				/*calls onChange if nextProps has changed*/
		if (JSON.stringify(this.props.defaultValue)!==JSON.stringify(nextProps.defaultValue)){
			if (nextProps.defaultValue!==undefined){
				var node = ReactDOM.findDOMNode(this.refs.selectpicker);
				if(nextProps.defaultValue.hasOwnProperty("parentId")){
					node.value = JSON.stringify(nextProps.defaultValue);
				}else {
					node.value = nextProps.defaultValue;
				}
			}
		}

		var selected;
		if (JSON.stringify(this.props.items)!==JSON.stringify(nextProps.items)){
		//if no items given its always null
			if (nextProps.items.length===0){
				this.props.onChange(null)
				return;
			}

			if (nextProps.items[0].items===undefined) {
				selected = nextProps.items[0].id
			}
			else {
					selected = {
					parentId: nextProps.items[0].id,
					childId: nextProps.items[0].items[0].id
				}
			}
			this.props.onChange(selected)
		}
	};
	onItemSelected = (evt) =>  {
		var val = evt.target.value;
			try{
				var obj = JSON.parse(val);
				this.props.onChange(obj);
			}catch(e){
				this.props.onChange(evt.target.value);
			}
	};
	renderOptGroup = (item) =>  {
		if (item.items){
			var optNodes = this.renderOpt(item.items, item.id);
			return <optgroup
					key={item.id}
					label={item.name}>
						{optNodes}
					</optgroup>
		}
	};
	renderOpt = (items, parentId) => {
		return items.map(function(item){
			var value = parentId!==undefined ? JSON.stringify({'parentId': parentId, 'childId': item.id}) : item.id;
			return <option
				key={item.id}
				value={value}>
				{item.name}
				</option>
		})
	};
  render() {
		var that = this;
		var safeItems = this.props.items ? this.props.items : [];
		var nodes = safeItems.map(function(item){
			return item.items ? that.renderOptGroup(item) : that.renderOpt([item]);
		});
		return (
			<select
				style={styles.select}
				disabled={this.props.disabled}
				onChange={this.onItemSelected}
				ref="selectpicker" >
				{nodes}
			</select>
    );
  }
}


var styles = {
  select: {
	'-webkit-appearance': 'none',
    '-moz-appearance':    'none',
     '-webkit-border-radius': '0px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
    backgroundColor: 'white',
    cursor: 'pointer',
    width:' 100%',
    height: '35px',
    border: 'none',
    padding: '5px'
  }
}

	Selectpicker.propTypes = {
		items: PropTypes.arrayOf(PropTypes.shape({
			id: PropTypes.string,
			name: PropTypes.string,
			items: PropTypes.arrayOf(PropTypes.shape({
				id: PropTypes.string,
				name: PropTypes.string
			}))
		})),
		onChange: PropTypes.func.isRequired,
		disabled: PropTypes.bool
	};
	Selectpicker.defaultProps = {
		disabled: false
	};
	
export default Radium(Selectpicker);



// WEBPACK FOOTER //
// ./src/App/Common/selectpicker.jsx